import React, { Fragment, useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Input,
  Form,
} from "reactstrap";
import { JobSearchContext } from "../../../../JobSearch/JobSearchContext";
import { fetchCompanyRequest } from "../../../../redux/company/actions";

const Company = () => {
  const dispatch = useDispatch();
  const { filters, updateFilters } = useContext(JobSearchContext);

  const companyReducerData =
    useSelector((state) => state.companyReducer) || [];

  let companyData = [];
  if (
    !companyReducerData.isLoading &&
    companyReducerData.data &&
    companyReducerData.data.data
  ) {
    companyData = companyReducerData.data.data;
  }

  const [isFilter, setIsFilter] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    dispatch(fetchCompanyRequest(""));
  }, [dispatch]);

  const handleInputChange = (e) => {
    const keyword = e.target.value;
    setSearchKeyword(keyword);
    dispatch(fetchCompanyRequest(keyword));
  };

  const handleCheckboxChange = (company) => {
    const current =
      Array.isArray(filters?.company) ? filters.company : [];

    const exists = current.find((item) => item.value === company.value);

    let updatedCompany = [];
    if (exists) {
      updatedCompany = current.filter(
        (item) => item.value !== company.value
      );
    } else {
      updatedCompany = [...current, company];
    }

    updateFilters({ company: updatedCompany });
  };

  const mergedCompanyData = [...companyData];

  if (filters && Array.isArray(filters.company)) {
    filters.company.forEach((filterCompany) => {
      if (
        !mergedCompanyData.some(
          (company) => company.value === filterCompany.value
        )
      ) {
        mergedCompanyData.push(filterCompany);
      }
    });
  }

  const sortedCompanyData = mergedCompanyData.sort((a, b) => {
    const isSelectedA = filters?.company?.some(
      (item) => item.value === a.value
    );
    const isSelectedB = filters?.company?.some(
      (item) => item.value === b.value
    );
    return isSelectedA === isSelectedB ? 0 : isSelectedA ? -1 : 1;
  });

  return (
    <Fragment>
      <Col xl="12">
        <Card>
          <CardHeader className="py-3" onClick={() => setIsFilter(!isFilter)}>
            <h5 className="mb-0 p-0">Company</h5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <CardBody className="animate-chk border-0 ">
              <Form
                className="theme-form"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="job-filter mb-3">
                  <div className="faq-form">
                    <Input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Search company.."
                      value={searchKeyword}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </Form>
              {companyReducerData.isLoading ? (
                <div>Loading...</div>
              ) : (
                <div
                  className="company-checkbox custom-scrollbar"
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {sortedCompanyData.length > 0 ? (
                    sortedCompanyData.map((company, index) => (
                      <label key={index} className="d-flex">
                        <Input
                          className="checkbox_animated mr-2"
                          id={`company-chk-${index}`}
                          type="checkbox"
                          checked={filters?.company?.some(
                            (item) => item.value === company.value
                          )}
                          onChange={() => handleCheckboxChange(company)}
                        />
                        {company.label}
                      </label>
                    ))
                  ) : (
                    <p>No data found</p>
                  )}
                </div>
              )}
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default Company;

